import type { FC } from 'react';
import React, { memo, useState, useEffect } from 'react';
import isEqual from 'lodash/isEqual';

import type { ADNode } from '@atlaskit/editor-common/utils/validator';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import type { KeyableInterface } from './types.ts';
import { handleLiveSearchNode } from './handleADF.tsx';
import { LiveSearchTemplate } from './LiveSearchTemplate.tsx';

export interface LiveSearchInterface {
	macroNode: ADNode;
}

const LiveSearchComponent: FC<LiveSearchInterface> = ({ macroNode }) => {
	const [liveSearchOptions, setLiveSearchOptions] = useState<KeyableInterface>(
		handleLiveSearchNode(macroNode),
	);

	useEffect(() => {
		setLiveSearchOptions(handleLiveSearchNode(macroNode));
	}, [macroNode]);

	return <LiveSearchTemplate config={liveSearchOptions} />;
};

export const LiveSearch: React.NamedExoticComponent<LiveSearchInterface> = memo(
	withErrorBoundary({
		attribution: Attribution.SMARTS,
	})(LiveSearchComponent),
	isEqual,
);
